<script setup lang="ts">
import {ModelList} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import {ref} from "vue";
import type {ScheduleFilter} from "@/types/Wiser/schedule.ts";
import ScheduleFilterForm from "@/views/Wiser/ScheduleFilterForm.vue";
const modelFilter = ref<ScheduleFilter>({page: '1', perPage: '25'});
</script>

<template>
  <Dashboard />
  <div class="container">
    <ScheduleFilterForm v-model="modelFilter" />
    <ModelList class="model-list model-list-schedule" model="Schedule" :filter="modelFilter" />
  </div>
</template>

<style scoped></style>
